import React from "react";
import _ from "underscore";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router";
import { replace } from "react-router-redux";
import * as WebRoutes from "@travellocal/utils/webRoutes";

interface OwnProps {
  /**
   * From react-router
   */
  location: {
    query: {
      locationSlug?: string;
      ltoId?: string;
    };
  }
}

interface DispatchProps {
  redirect: (locationSlug: string|null, qsParams: any) => any;
}

const dispatchToProps = (dispatch): DispatchProps => ({
  redirect: (locationSlug, qsParams) => dispatch(replace(WebRoutes.enquiryForm({ ...qsParams, locationSlug, campaign: "enquire-redirect" }))),
});

/**
 * Component to redirect from old enquiry form to the new one. TODO reimplement with RR4 upgrade.
 *
 * ```
 * /enquire -> /plan-your-trip
 * /enquire?countrySlug=armenia -> /plan-your-trip/armenia
 * /enquire?ltoId=1 -> /plan-your-trip
 * ```
 */
class Redirect extends React.Component<OwnProps & DispatchProps> {
  public componentWillMount() {
    const { locationSlug, ltoId, ...newQs } = this.props.location.query;
    this.props.redirect(locationSlug, newQs);
  }

  public render() {
    return (
      <div style={{ textAlign: "center", color: "#111" }}>
        <Helmet title="Redirecting..." />

        <h1>Redirecting...</h1>
        <Link to={WebRoutes.enquiryForm({ campaign: "enquire-redirect-click" })}>Click here if you're not redirected after a few seconds.</Link>
      </div>
    );
  }
}

export const EnquireLegacyRedirect = connect(null, dispatchToProps)(Redirect);
